import sortObject from 'sort-object-keys'

export default {
    methods: {
        isset: function (string) {
            if (typeof string === 'string') {
                return string.trim().length > 0 && string !== 'N/A'
            } else {
                return !(typeof string === 'undefined' || string === null)
            }
        },
        validateField: async function (refs, field) {
            if (refs[field]) {
                const provider = refs[field]
                let result = await provider.validate()
                return (result.valid === true)
            }
        },
        zeroPad(num, places) {
            return String(num).padStart(places, '0')
        },
        calculateAge(date) {

            let type = Object.prototype.toString.call(date)
            let now = new Date()

            // convert dateStrings and timestamps to a Date
            if (type === '[object String]' || type === '[object Number]') {
                date = new Date(date)
            }

            let yearDiff = now.getFullYear() - date.getFullYear()
            let monthDiff = now.getMonth() - date.getMonth()
            let pastDate = now.getDate() < date.getDate()

            if (monthDiff < 0 || (monthDiff === 0 && pastDate)) {
                yearDiff--
            }

            return yearDiff
        },
        prettifyResidentialStatus(key) {
            const values = {
                'HO': 'Homeowner',
                'PT': 'Private tenant',
                'CT': 'Council tenant',
                'LP': 'Living with parents',
                'O': 'Other'
            }

            return values[key]
        },

        prettifyAdditionalIncome(additionalIncomeIndicator, otherHouseholdIncome) {
            let text = 'No'

            if (additionalIncomeIndicator == 'Y' && otherHouseholdIncome !== '') {
                text = `${this.formatAmount(otherHouseholdIncome)}`
            } else if (additionalIncomeIndicator == 'Y') {
                text = 'Yes'
            }

            return text
        },

        prettifyCreditType(creditType, creditAmount) {
            let text = `No`

            if (creditType == 'BT' && creditAmount !== '') {
                text = `Yes, for the amount of ${this.formatAmount(creditAmount)}`
            } else if (creditType == 'BT') {
                text = 'Yes'
            }

            return text
        },

        prettifyEmploymentStatus(key) {
            const values = {
                'EM': 'Employed',
                'SE': 'Self Employed',
                'HO': 'Homemaker',
                'RE': 'Retired',
                'UN': 'Unemployed',
                'ST': 'Student',
            }

            return (key in values) ? values[key] : null
        },
        prettifyAddress(addressObject) {

            if (!addressObject) { return null }

            let preview = ''

            Object.entries(addressObject).forEach(([key, value]) => {
                if (!['yearsAtAddress', 'monthsAtAddress'].includes(key)) {
                    if (key == 'postCode') {
                        value = value.replace(/^(.*)(\d)/, "$1 $2")
                    }

                    if (key !== 'deleted') {
                        preview += `${value}${(!['postCode', 'houseNumber'].includes(key)) ? ', ' : ' '}`
                    }
                }
            })

            return preview
        },
        prettyifyBooleanString(string) {
            return string == 'Y' ? 'Yes' : 'No'
        },
        prettyifyCashAdvanceIndicatorString(string) {

            let value = ''

            switch (string) {
                case 'Y':
                    value = 'Yes'
                    break;
                case 'N':
                    value = 'No'
                    break;
                case 'U':
                    value = '-'
                    break;
            }

            return value
        },
        getBooleanFromString(string) {
            return string == 'Y'
        },
        capatilise(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        formatAmount(amount) {

            if (!amount) {
                amount = 0
            }

            let value = parseFloat(amount)

            return value.toLocaleString('en-GB', {
                style: 'currency',
                currency: 'GBP',
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
            })
        },
        lower(string) {
            return string.toLowerCase()
        },
        isSmallScreen() {
            return (this.$screen.width <= 768)
        },
        getFieldFromAddress(object, key) {

            if (!Array.isArray(object.address.components)) {
                if (key in object.address.components) {
                    return object.address.components[key]
                }
                return
            }

            let record = object.address.components.find(component => component[key])

            if (record && record[key]) {
                return record[key]
            }
        },
        savePreviousTimeAtAddress() {
            this.toggles.changePreviousTimeAtAddress = false
            this.previousAddress.monthsAtAddress = this.previousTimeAtAddress.months
            this.previousAddress.yearsAtAddress = this.previousTimeAtAddress.years
            this.$root.$emit('closeEditFields')
        },
        saveCurrentTimeAtAddress() {

            this.toggles.changeCurrentTimeAtAddress = false

            let currentTimeAtAddress = this.currentTimeAtAddress

            this.currentAddress.monthsAtAddress = currentTimeAtAddress.months
            this.currentAddress.yearsAtAddress = currentTimeAtAddress.years

            this.$root.$emit('closeEditFields')

            if (this.currentAddress.yearsAtAddress >= parseInt(process.env.VUE_APP_ADDRESS_MIN_YEARS)) {
                this.previousAddress = null
                this.toggles.previousAddressRequired = false
                this.toggles.showPreviousAddressEntry = false
                return
            }

            if (!this.previousAddress) {
                this.toggles.previousAddressRequired = true
                this.toggles.showPreviousAddressEntry = true
            }
        },
        setSelectedAddress(object) {

            this.toggles.showAddressEntry = true

            let addressObject = {}

            let organisation = this.getFieldFromAddress(object, 'organisation1')
            let streetNumber = this.getFieldFromAddress(object, 'streetNumber1')
            let townName = this.getFieldFromAddress(object, 'townName')
            let subBuilding = this.getFieldFromAddress(object, 'subBuilding1')
            let building = this.getFieldFromAddress(object, 'building1')
            let locality = this.getFieldFromAddress(object, 'locality1')
            let streetName = this.getFieldFromAddress(object, 'street1')
            let countyName = this.getFieldFromAddress(object, 'countyName')
            let postCode = this.getFieldFromAddress(object, 'postalCode1')

            if (organisation) { addressObject.organisation = organisation }
            if (subBuilding) { addressObject.flatNumber = subBuilding }
            if (building) { addressObject.houseName = building }
            if (streetNumber) { addressObject.houseNumber = streetNumber }
            if (streetName) { addressObject.streetName = streetName }
            if (locality) { addressObject.localityName = locality }
            if (countyName) { addressObject.countyName = countyName }

            if (locality && !townName) {
                addressObject.townName = locality
                delete addressObject.localityName
            } else if (townName) {
                addressObject.townName = townName
            }

            addressObject.postCode = this.formatPostCode(postCode)

            if (object.id == 'previous') {

                let prevAddress = addressObject
                let currAddress = { ...this.currentAddress }

                delete currAddress.yearsAtAddress
                delete currAddress.monthsAtAddress

                if (JSON.stringify(currAddress) === JSON.stringify(prevAddress)) {
                    alert(`Previous address can't be the same as your current address`)
                    return
                }

                prevAddress.yearsAtAddress = object.time.years
                prevAddress.monthsAtAddress = object.time.months

                this.previousAddress = this.sortAddressObject(prevAddress)
                this.toggles.showPreviousAddressEntry = false

                this.$root.$emit('closeEditFields')

                return
            }

            this.currentAddress = this.sortAddressObject(addressObject)

            this.currentAddress.yearsAtAddress = object.time.years
            this.currentAddress.monthsAtAddress = object.time.months
            this.toggles.showAddressEntry = true

            this.$root.$emit('closeEditFields')

            // if customer has lived at address less than x years, show
            // previous address entry for a complete address picture 

            if (object.time.years < parseInt(process.env.VUE_APP_ADDRESS_MIN_YEARS)) {
                this.toggles.previousAddressRequired = true
                this.toggles.showPreviousAddressEntry = true
                return
            }

            this.previousAddress = null
            this.toggles.previousAddressRequired = false
        },
        splitDateOfBirthFieldsAndDisplay() {
            let splitBirthDate = this.birthDate.split('-')
            this.yearOfBirth = this.isset(splitBirthDate[0]) ? splitBirthDate[0] : ''
            this.monthOfBirth = this.isset(splitBirthDate[1]) ? splitBirthDate[1] : ''
            this.dayOfBirth = this.isset(splitBirthDate[2]) ? splitBirthDate[2] : ''
        },
        changeCurrentAddress() {
            this.toggles.showAddressEntry = true
            this.previousAddress = null
            this.currentAddress = null

            this.toggles.showTimeAtAddressSelection = false
            this.toggles.previousAddressRequired = false
        },
        cancelCurrentTimeAtAddress() {
            this.toggles.changeCurrentTimeAtAddress = false
            this.syncCurrentTimeAtAddressFromState()
        },
        syncCurrentTimeAtAddressFromState() {
            if (this.currentAddress) {
                this.currentTimeAtAddress.years = this.currentAddress.yearsAtAddress
                this.currentTimeAtAddress.months = this.currentAddress.monthsAtAddress
            }
        },
        changeTimeAtPreviousAddress() {
            if (this.previousAddress) {
                this.previousTimeAtAddress.years = this.previousAddress.yearsAtAddress
                this.previousTimeAtAddress.months = this.previousAddress.monthsAtAddress
            }
            this.toggles.changePreviousTimeAtAddress = true
        },
        uppercase(string) {
            return string.toUpperCase()
        },
        async submit() {

            let loader = this.$loading.show({
                opacity: 0.5,
                canCancel: false,
                color: '#58595b'
            })

            try {

                let data = { ...this.$store.state }


                if (data.person.ukResidencyCode == '') {
                    loader.hide();
                    this.$scrollTo(`#WhereYouLive`)
                    return
                }
                if (data.person.cashAdvanceIndicator == '') {
                    data.person.cashAdvanceIndicator = 'U'
                }

                if (!data.person.currentAddress) {
                    loader.hide()
                    this.$scrollTo(`#WhereYouLive`)
                    return
                }

                if (data.person.currentAddress && data.person.currentAddress.yearsAtAddress < parseInt(process.env.VUE_APP_ADDRESS_MIN_YEARS) && !data.person.previousAddress) {
                    loader.hide()
                    this.$scrollTo(`#WhereYouLive`)
                    return
                }

                let formValid = await this.isFormValid()

                if (formValid == false) {
                    loader.hide()
                    return
                }

                //Converting creditRequested object to array
                // if (data.creditRequested.creditType == 'BT') {
                //     let myJSON = '{"creditType": ' + '"'+ data.creditRequested.creditType + '", "creditAmount": ' + data.creditRequested.creditAmount + '}';
                //     const obj = JSON.parse(myJSON);
                //     data.creditRequested = obj;
                // }

                //rounding up creditAmount to whole number
                if (data.creditRequested.creditType == 'BT' && data.creditRequested.creditAmount) {
                    let tempInt = Math.round(data.creditRequested.creditAmount);
                    data.creditRequested.creditAmount = tempInt;
                }
                let internal = data.internal

                let requestData = this.removeExtraRequestFields(data)

                if (internal.campaign != '') {
                    requestData.campaign = internal.campaign
                }
                if (internal.pcr != '') {
                    requestData.pcr = internal.pcr
                }
                //eslint-disable-next-line no-console
                //console.log(requestData)
                let response = await this.axios.post(process.env.VUE_APP_API_URL, requestData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': process.env.VUE_APP_CLIENT_SECRET
                    }
                })

                if (response.status == 200 && response.data.quotation && response.data.quotation.productResults && response.data.quotation.productResults.length > 0) {
                    this.outcome = response.data
                    loader.hide()
                    this.$scrollTo(`header`)
                    this.$router.push('results')
                    return
                }

                this.$router.push('unable-to-offer')
                this.$scrollTo(`header`)
                loader.hide()

            } catch (error) {
                loader.hide()
                this.$router.push('error-occurred')
            }
        },
        async isFormValid() {

            let self = this
            let supportedChildren = ['AboutYourself', 'WhereYouLive', 'WorkAndFinances']
            let supportedSubChildren = ['AddressSearch']
            let hasScrolled = false

            let childComponents = this.$children.filter(child => supportedChildren.includes(child.$options.name))

            for (let index = 0; index < childComponents.length; index++) {

                const component = childComponents[index]

                for (let ref in component.$refs) {

                    if (!component.$refs[ref]) {
                        continue
                    }

                    if (ref == 'WhereYouLive') {
                        let filteredComponents = component.$refs[ref].$children.filter(child => supportedSubChildren.includes(child.$options.name))
                        for (let childIndex = 0; childIndex < filteredComponents.length; childIndex++) {
                            const subComponent = filteredComponents[childIndex]
                            if (subComponent.$refs[subComponent.$options.name]) {
                                let result = await subComponent.$refs[subComponent.$options.name].validate()
                                if (!result && !hasScrolled) {
                                    hasScrolled = true
                                    self.$scrollTo(`#${subComponent.$options.name}`)
                                }
                            }
                        }
                    } else {
                        let result = await component.$refs[ref].validate()
                        if (!result && !hasScrolled) {
                            hasScrolled = true
                            self.$scrollTo(`#${ref}`)
                        }
                    }
                }
            }

            return !hasScrolled

        },
        getAggregatorData: async function (identifier) {

            let loader = this.$loading.show({
                opacity: 1,
                canCancel: false,
                color: '#58595b'
            })

            try {

                let response = await this.axios.get(process.env.VUE_APP_AGGREGATOR_API + identifier, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': process.env.VUE_APP_AGGREGATOR_API_KEY
                    }
                })

                if (response.status == 200) {
                    loader.hide()
                    return response.data
                }

                loader.hide()
                return false

            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error)
                loader.hide()
            }
        },
        truncate(str, max, add) {
            add = add || '...';
            return (typeof str === 'string' && str.length > max ? str.substring(0, max) + add : str)
        },
        formatPostCode(postCode) {
            return postCode.replace(' ', '').toUpperCase()
        },
        prettifyTimeAtAddress(address) {
            if (!address) { return '' }
            return `${address.yearsAtAddress} ${address.yearsAtAddress > 0 ? 'years' : 'year'}, ${address.monthsAtAddress} ${address.monthsAtAddress > 0 ? 'months' : 'month'}`
        },

        sortAddressObject(address) {

            address.postCode = this.formatPostCode(address.postCode)

            return sortObject(address, [
                'organisation',
                'flatNumber',
                'houseName',
                'houseNumber',
                'streetName',
                'countyName',
                'localityName',
                'townName',
                'postCode'
            ])
        },
        removeExtraRequestFields(object) {

            // we shouldn't be mixing business logic with UI but given the aggregators are allowed to send whatever data
            // they want without any validation done at time of submission and lack of API transformations on GET, we have little
            // choice to handle these scenarios in the UI or it would cause a negative user experience.

            if (!object || !object.person) {
                return
            }

            delete object.internal

            const personFieldsToRemove = [
                'middleName',
                'callBackDate',
                'homePhoneNumber',
                'workPhoneNumber'
            ]

            personFieldsToRemove.forEach(function (key) {
                if (key in object.person) {
                    delete object.person[key]
                }
            })

            if (object.person.currentAddress && object.person.currentAddress.organisation) {
                delete object.person.currentAddress.organisation
            }

            if (object.person.previousAddress == null) {
                delete object.person.previousAddress
            }

            if (object.productId == '') {
                delete object.productId
            }

            if (object.person.previousAddress && object.person.previousAddress.organisation) {
                delete object.person.previousAddress.organisation
            }

            if (object.person.mobilePhoneNumber && /^\d+$/.test(object.person.mobilePhoneNumber)) {
                object.person.mobilePhoneNumber = object.person.mobilePhoneNumber.replace(/\s/g, '')
            } else {
                delete object.person.mobilePhoneNumber
            }

            // we have an current address but don't have madatory fields
            if (object.person.currentAddress && (!object.person.currentAddress.postCode || !object.person.currentAddress.townName)) {
                delete object.person.currentAddress
            }


            // we have an previous address but don't have madatory fields
            if (object.person.previousAddress && (!object.person.previousAddress.postCode || !object.person.previousAddress.townName)) {
                delete object.person.previousAddress
            }

            // we have an current address but don't have madatory fields
            if (object.person.currentAddress && !object.person.currentAddress.flatNumber && !object.person.currentAddress.houseName && !object.person.currentAddress.houseNumber) {
                delete object.person.currentAddress
            }

            // we have an previous address but don't have madatory fields
            if (object.person.previousAddress && !object.person.previousAddress.flatNumber && !object.person.previousAddress.houseName && !object.person.previousAddress.houseNumber) {
                delete object.person.previousAddress
            }

            // we have an previous address but don't have years at address
            if (object.person.previousAddress && object.person.previousAddress.yearsAtAddress == undefined) {
                delete object.person.previousAddress
            }

            // we have an previous address and years at address but don't have months at address
            if (object.person.previousAddress && object.person.previousAddress.yearsAtAddress !== undefined && object.person.previousAddress.monthsAtAddress == undefined) {
                object.person.previousAddress.monthsAtAddress = 0
            }

            // we have an current address but don't have years at address
            if (object.person.currentAddress && object.person.currentAddress.yearsAtAddress == undefined) {
                delete object.person.currentAddress
            }

            // we have an current address and years at address but not months at address
            if (object.person.currentAddress && object.person.currentAddress.yearsAtAddress !== undefined && object.person.currentAddress.monthsAtAddress == undefined) {
                object.person.currentAddress.monthsAtAddress = 0
            }

            if (object.person.occupation == '') {
                delete object.person.occupation
            }

            if (object.fadcode == '') {
                delete object.fadcode
            }

            if (object.person.advanceCas)

                if (object.creditRequested) {
                    delete object.creditRequested
                }

            if (object.person.incomeAmount) {
                object.person.incomeAmount = parseInt(object.person.incomeAmount)
            }

            if (object.person.monthlyOutgoings) {
                object.person.monthlyOutgoings = parseInt(object.person.monthlyOutgoings)
            }

            if (object.person.additionalIncomeIndicator == 'N') {
                delete object.person.otherHouseholdIncome
            }

            if (object.person.additionalIncomeIndicator == '' || object.person.additionalIncomeIndicator == 'Y' || object.person.additionalIncomeIndicator == 'N') {
                delete object.person.additionalIncomeIndicator
            }

            if (object.person.otherHouseholdIncome && object.person.otherHouseholdIncome != '' && object.person.otherHouseholdIncome >= 1) {
                object.person.otherHouseholdIncome = parseInt(object.person.otherHouseholdIncome)
            }

            if (object.person.otherHouseholdIncome == '') {
                delete object.person.otherHouseholdIncome
            }

            // remove creditRequested object from json request if creditType = 'N' or empty
            if (object.creditRequested && (object.creditRequested.creditType == 'N' || object.creditRequested.creditType == '')) {
                delete object.creditRequested
            }

            return object
        },
        /**
         * Return a fixed number to a set
         * decimal place without rounding
         * @param Number number
         * @param Number decimals
         * @param Boolean pad
         */
        toFixed(number, decimals, pad) {
            let re = new RegExp('^-?\\d+(?:.\\d{0,' + (decimals || -1) + '})?');
            let fixed = number.toString().match(re)[0];

            if (pad !== true) {
                return fixed;
            }

            var numberValue = Number(fixed);

            if (String(numberValue).split(".").length < 2 || String(numberValue).split(".")[1].length <= 2) {
                numberValue = numberValue.toFixed(2);
            }

            return numberValue;
        }
    },
}